export enum IconPack {
  ANT_DESIGN_ICONS = "ai",
  BOOTSTRAP_ICONS = "bs",
  BOXICONS = "bi",
  CIRCUM_ICONS = "ci",
  CSS_GG = "cg",
  DEVICONS = "di",
  FEATHER = "fi",
  FLAT_COLOR_ICONS = "fc",
  FONT_AWESOME_5 = "fa",
  FONT_AWESOME_6 = "fa6",
  GAME_ICONS = "gi",
  GITHUB_OCTICONS_ICONS = "go",
  GROMMET_ICONS = "gr",
  HEROICONS = "hi",
  HEROICONS_2 = "hi2",
  ICOMOON_FREE = "im",
  ICONS8_LINE_AWESOME = "lia",
  IONICONS_4 = "io",
  IONICONS_5 = "io5",
  LUCIDE = "lu",
  MATERIAL_DESIGN_ICONS = "md",
  PHOSPHOR_ICONS = "pi",
  RADIX_ICONS = "rx",
  REMIX_ICON = "ri",
  SIMPLE_ICONS = "si",
  SIMPLE_LINE_ICONS = "sl",
  TABLER_ICONS = "tb",
  THEMIFY_ICONS = "tfi",
  TYPICONS = "ti",
  VS_CODE_ICONS = "vsc",
  WEATHER_ICONS = "wi",
}

export const ReverseIconPack: Record<string, IconPack> = {
  ai: IconPack.ANT_DESIGN_ICONS,
  bs: IconPack.BOOTSTRAP_ICONS,
  bi: IconPack.BOXICONS,
  ci: IconPack.CIRCUM_ICONS,
  cg: IconPack.CSS_GG,
  di: IconPack.DEVICONS,
  fi: IconPack.FEATHER,
  fc: IconPack.FLAT_COLOR_ICONS,
  fa: IconPack.FONT_AWESOME_5,
  fa6: IconPack.FONT_AWESOME_6,
  gi: IconPack.GAME_ICONS,
  go: IconPack.GITHUB_OCTICONS_ICONS,
  gr: IconPack.GROMMET_ICONS,
  hi: IconPack.HEROICONS,
  hi2: IconPack.HEROICONS_2,
  im: IconPack.ICOMOON_FREE,
  lia: IconPack.ICONS8_LINE_AWESOME,
  io: IconPack.IONICONS_4,
  io5: IconPack.IONICONS_5,
  lu: IconPack.LUCIDE,
  md: IconPack.MATERIAL_DESIGN_ICONS,
  pi: IconPack.PHOSPHOR_ICONS,
  rx: IconPack.RADIX_ICONS,
  ri: IconPack.REMIX_ICON,
  si: IconPack.SIMPLE_ICONS,
  sl: IconPack.SIMPLE_LINE_ICONS,
  tb: IconPack.TABLER_ICONS,
  tfi: IconPack.THEMIFY_ICONS,
  ti: IconPack.TYPICONS,
  vsc: IconPack.VS_CODE_ICONS,
  wi: IconPack.WEATHER_ICONS,
};
